<template>
  <div class="OrderHistory">
    <ATable
      ref="table"
      hide-button-insert
      :placeholder="placeholder"
      :search_field="search_field"
      :data="items"
      @row-click="handleClickRow"
    >
      <div slot="search">
        <div class="inline">
          <APeriodSelector ref="period" @change="handleChangePeriod" />
        </div>
        <div class="inline">
          <el-button
            type="primary"
            size="mini"
            round
            v-shortkey="['f5']"
            @shortkey.native="handleClickSearch"
            @click="handleClickSearch"
          >검색(F5)</el-button>
        </div>
      </div>
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"
        :width="$width.index"
      />
      <el-table-column
        prop="code"
        label="발주번호"        
        width="100"
      />
      <el-table-column
        prop="seq"
        label="번호"
        width="50"
      />
      <el-table-column
        prop="order_date"
        label="발주일"        
        :width="$width.date"
      />
      <el-table-column
        prop="product_name"
        label="품목"        
        show-overflow-tooltip
      />
      <el-table-column
        prop="size"
        :label="$t('lang.size')"
        :width="$width.size"
        show-overflow-tooltip
      />
      <el-table-column
        prop="amount"
        label="수량"
        class-name="cell-number"
        :width="$width.amount"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="unit_name"
        label="단위"
        :width="$width.unit_name"
      />
      <el-table-column
        prop="cost"
        label="단가"
        class-name="cell-number"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="supply_price"
        label="공급가액"
        class-name="cell-number"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="tax"
        label="세액"
        class-name="cell-number"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="desc"
        label="비고"
        width="400"
      />
      <el-table-column
        prop="created_user_name"
        label="등록인"
        :width="$width.username"
      />
    </ATable>
  </div>
</template>

<script>

export default {
  name: "OrderHistory",
  data() {
    return {
      title: this.$t("title.order_reg"),
      search_field: ['code', 'product_name'],
      placeholder: '발주번호, 품목',
      items: [],      
      loading: false,
      period: {},
    };
  },
  props: {
    customer_id: {
      type: Number,
      required: true
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {    
    loadData() {
      this.loading = true;
      let params = { customer_id: this.customer_id };
      this.api.listOrderDetail(this.period, params).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },
    reload() {
      this.loadData();
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }      
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },    
    handleClickRow(data) {
      this.api.selectOrder(data.order_id).then(res => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.$emit('selected', Object.assign({}, res.data))
      });
    }
  }
};
</script>